import * as React from 'react';
import { Loader } from 'semantic-ui-react';

import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { AlphaDataTable } from '../AlphaDataTable/AlphaDataTable';

import './SelectedAlphasMain.scss';

interface SelectedAlphasMainProps {
  settingsTableHeader: any;
  settingsTableValues: any;
  stagePerformanceColumnsTypes: any;
  isLoading: boolean;
}

const SelectedAlphasMain = ({
  settingsTableHeader,
  settingsTableValues,
  stagePerformanceColumnsTypes,
  isLoading,
}: SelectedAlphasMainProps) => {
  if (isLoading) {
    return (
      <div className="loader">
        <Loader active={true} inline="centered" size="massive" />
      </div>
    );
  } else if (settingsTableValues) {
    return (
      <div className="selected__alphas--table">
        <AlphaDataTable
          tableRowsProperties={settingsTableHeader}
          tableRowsRecords={settingsTableValues}
          stagePerformanceColumnsTypes={stagePerformanceColumnsTypes}
          dataType={stagePerformanceColumnsTypes}
          typeStage="is"
        />
      </div>
    );
  } else {
    return (
      <div className="no-selected__alphas">
        <FormattedMessageHelper id="no.selected.alphas" />
      </div>
    );
  }
};

export default SelectedAlphasMain;
